(function () {
    'use strict';

    a3_cabin_reports.directive('autorefresh', autorefresh);

    function autorefresh($interval, $timeout, PushNotifier, InfoAPIService, FlightFactory, PaxInfoFactory, 
        AircaftPositionsFactory, CrewCallFactory, PreviousDutyFactory, CrewRouteFactory) {

        function link($scope, element, attrs) {

            //var flight = $scope.flight;
            //$scope.flight from parent scope

            //Auto refresh functionality start
            var browserNotificationsEnabled = false;
            var autoUpdateInterval = null;
            var autoUpdateIntervalTimeOffset = null;
            $scope.showAlternativeNotifications = false;
            $scope.showAutoUpdatePanel = false;

            //Check if push notification are enabled
            PushNotifier.CheckForPermissionsAndSupport().then(function (res) {
                browserNotificationsEnabled = res
            });

            var ScheduledDepartureTimeStamp = 0;
            if($scope.flight){
             ScheduledDepartureTimeStamp = moment.utc($scope.flight.ScheduledDeparture).valueOf();
            }
            var now = moment().valueOf();

            $scope.showAutoUpdatePanel = (ScheduledDepartureTimeStamp - (70 * 60000)) <= now
                && (ScheduledDepartureTimeStamp + (30 * 60000)) >= now
                && $scope.flight.DepartureEU;

            $scope.radioModel = false;

            $scope.$watch('radioModel', function (value) {
                if (value == true)
                    autoflightInfoInterval();
                if (value == false) {
                    $interval.cancel(autoUpdateInterval);
                    autoUpdateInterval = null;
                }
            });

            function autoflightInfoInterval() {
                var intervalTime = timerDelayGenerator($scope.flight.ScheduledDeparture);
                var currentInfo = null;
                PushNotifier.formatInfoToCompare($scope.flight.FlightId)
                    .then(function (data) {
                        currentInfo = data;

                        if (intervalTime > 0) {
                            InfoAPIService.getPax($scope.flight.FlightId)
                                .then(function (responseData) {
                                    $scope.flight = FlightFactory.getFlightFromTotalFlights($scope.flight.FlightId);

                                    //UPDATE CREW INFO
                                    //1. First remove all additional info (phone numbers & previous duties) for this flight
                                    CrewCallFactory.cleanFlightCrewNumbers($scope.flight.FlightId);
                                    PreviousDutyFactory.cleanFlightPreviousDuties($scope.flight.FlightId);

                                    //2. Then save any fetched info
                                    if( responseData.data.data.FlightInfo){
                                        var crew = responseData.data.data.FlightInfo.crew;
                                        CrewCallFactory.saveFlightPhoneNumbers($scope.flight.FlightId, crew, $scope.flight.ScheduledArrival, $scope.flight.ScheduledDeparture);
                                        PreviousDutyFactory.saveFlightPreviousDuties($scope.flight.FlightId, crew);
                                    }

                                    PaxInfoFactory.getPaxInfoFromStorage($scope.flight.FlightId, function (paxInfo) {
                                        $scope.paxInfo = paxInfo;
                                        
                                        
                                            if (paxInfo) {

                                                $scope.cStat = (paxInfo.PaxTotalC / paxInfo.ConfigurationC) * 100;
                                                $scope.yStat = (paxInfo.PaxTotalY / paxInfo.ConfigurationY) * 100;

                                                $scope.mealsChart = $scope.generateMealChart(paxInfo);

                                                var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
                                                var DepartureTimestamp = new Date($scope.flight.ScheduledDeparture).getTime();
                                                //20 minutes before takeoff
                                                if (DepartureTimestamp - listSentTimestamp <= 1200000) {
                                                    $scope.IsProvisional = false;
                                                }
                                            }
                                    });
                                    
                                    //Update scopes for the CrewRoutePanel in Flight-page
                                    $scope.crewRouteInfoPanel = CrewRouteFactory.getCrewRouteInfoPanel($scope.flight);

                                    $scope.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);

                                    $scope.flightETA = $scope.flight.ETA ?
                                        moment($scope.flight.ETA).valueOf() : new Date($scope.flight.ScheduledArrival).getTime();

                                    var updatedInfo = null;
                                    PushNotifier.formatInfoToCompare($scope.flight.FlightId).then(function (data) {
                                        updatedInfo = data;

                                        var changes = PushNotifier.compareAndExtractChanges(currentInfo, updatedInfo);
                                        var message = PushNotifier.MessageGenerator(changes);

                                        if (changes && changes.length > 0) {
                                            if (browserNotificationsEnabled) {
                                                try {
                                                    PushNotifier.Generate('Changes', message);
                                                } catch (e) {
                                                    $scope.changes = changes;
                                                    $scope.showAlternativeNotifications = true;
                                                }
                                            } else {
                                                $scope.changes = changes;
                                                $scope.showAlternativeNotifications = true;
                                            }
                                        }

            
                                    });

                                },
                                function (responseData) {
                                    if (browserNotificationsEnabled && window.navigator.onLine) {
                                        try {
                                            PushNotifier.Generate('Changes', 'Update failed');
                                        } catch(ex){
                                            //TODO: add related messagge KVEN,EPAP
                                        }
                                    }
                                });
                                    
                            if (intervalTime != autoUpdateIntervalTimeOffset) {
                                autoUpdateIntervalTimeOffset = intervalTime;
                                $interval.cancel(autoUpdateInterval);
                                autoUpdateInterval = $interval(autoflightInfoInterval, autoUpdateIntervalTimeOffset);
                            }

                        } else {
                            $interval.cancel(autoUpdateInterval);
                            $scope.showAutoUpdatePanel = false;
                        }
                    });
            }

            function timerDelayGenerator(departureTime) {
                var intervalTime = -1;
                var depTimestamp = moment.utc(departureTime).valueOf();
                var nowTimeStamp = moment().valueOf();

                var minutes = 60000;
                if (depTimestamp - 70 * minutes <= nowTimeStamp && depTimestamp + 30 * minutes >= nowTimeStamp) {
                    var absoluteMinuteDiff = Math.abs(depTimestamp - nowTimeStamp);
                    if (absoluteMinuteDiff <= 15 * minutes) {
                        intervalTime = 1 * minutes;
                    } else {
                        intervalTime = 3 * minutes;
                    }
                }
                return intervalTime;
            }
        }

        return {
            restrict: 'E',
            templateUrl: 'views/directives/autofresh.tpl.html',
            scope: false,
            link: link
        }
    }

})();   